document.addEventListener('DOMContentLoaded', () => {
	const observeElements = document.querySelectorAll('.observe');

	if (observeElements.length > 0) {
		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						entry.target.classList.add('active');
					}
				});
			},
			{
				root: null,
				rootMargin: '0px',
				threshold: 0.5,
			}
		);

		observeElements.forEach((el) => {
			observer.observe(el);
		});
	}
});
